/*
Template Name: Admin Template
Author: Wrappixel

File: js
*/
// ============================================================== 
// Auto select left navbar
// ============================================================== 
$(function() {
    "use strict";
     var url = window.location + "";
        var path = url.replace(window.location.protocol + "//" + window.location.host + "/", "");
        var element = $('ul#sidebarnav a,ul#user-sidebarnav a, #sidebar_menu a').filter(function() {
            return this.href === url || this.href === path;// || url.href.indexOf(this.href) === 0;
        });
        element.parentsUntil(".sidebar-nav").each(function (index)
        {
            if($(this).is("li") && $(this).children("a").length !== 0)
            {
                $(this).children("a").addClass("active");
                $(this).parent("ul#sidebarnav, ul#user-sidebarnav").length === 0
                    ? $(this).addClass("active")
                    : $(this).addClass("selected");
            }
            else if(!$(this).is("ul") && $(this).children("a").length === 0)
            {
                $(this).addClass("selected");
                
            }
            else if($(this).is("ul")){
                $(this).addClass('in');
            }
            
        });

    element.addClass("active"); 
    $('#sidebarnav a, #user-sidebarnav a, #sidebar_menu a').on('click', function (e) {
        
            if (!$(this).hasClass("active")) {
                // hide any open menus and remove all other classes
                $("ul", $(this).parents("ul:first")).removeClass("in");
                $("a", $(this).parents("ul:first")).removeClass("active");
                
                // open our new menu and add the open class
                $(this).next("ul").addClass("in");
                $(this).addClass("active");
                
            }
            else if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this).parents("ul:first").removeClass("active");
                $(this).next("ul").removeClass("in");
            }
    })
    $('#sidebarnav >li >a.has-arrow, #user-sidebarnav >li >a.has-arrow').on('click', function (e) {
        e.preventDefault();
    });
});

$(function() {
    "use strict";

    var $searchInput = $("#admin-sidebar-search");
    var $sidebarNav = $("#sidebarnav");

    if ($searchInput.length === 0 || $sidebarNav.length === 0) {
        return;
    }

    var $topLevelItems = $sidebarNav.children("li").not(":first").not(".sidebar-search");
    var $groupLabels = $topLevelItems.filter(".sidebar-group-label");
    var $menuItems = $topLevelItems.not(".sidebar-group-label");
    var $subMenus = $sidebarNav.find("ul.first-level, ul.second-level");

    $subMenus.each(function() {
        $(this).data("initial-open", $(this).hasClass("in"));
    });

    function normalizeText(text) {
        return (text || "").toLowerCase().replace(/\s+/g, " ").trim();
    }

    function updateGroupLabels() {
        var $currentGroupLabel = null;

        $topLevelItems.each(function() {
            var $item = $(this);

            if ($item.hasClass("sidebar-group-label")) {
                $currentGroupLabel = $item;
                $item.hide();
                return;
            }

            if ($item.is(":visible") && $currentGroupLabel) {
                $currentGroupLabel.show();
            }
        });
    }

    function restoreInitialSubMenuState() {
        $subMenus.each(function() {
            var $subMenu = $(this);
            if ($subMenu.data("initial-open")) {
                $subMenu.addClass("in");
            } else {
                $subMenu.removeClass("in");
            }
        });
    }

    function filterSidebarMenu() {
        var query = normalizeText($searchInput.val());

        if (!query.length) {
            $menuItems.show();
            $groupLabels.show();
            restoreInitialSubMenuState();
            return;
        }

        $menuItems.each(function() {
            var $item = $(this);
            var itemText = normalizeText($item.text());
            $item.toggle(itemText.indexOf(query) > -1);
        });

        $subMenus.each(function() {
            var $subMenu = $(this);
            var hasVisibleChildren = $subMenu.children("li:visible").length > 0;

            if (hasVisibleChildren) {
                $subMenu.addClass("in");
            } else if (!$subMenu.data("initial-open")) {
                $subMenu.removeClass("in");
            }
        });

        updateGroupLabels();
    }

    $searchInput.on("input", filterSidebarMenu);
});

// CUSTOM USER SIDEBAR
$(document).on("click", ".card-resources__item-resources, .first-level-item .sidebar-item", function(){
  localStorage.setItem('ClassName', 'in');
})

$(document).on("click", "#sidebar_menu > li", function(){
	localStorage.setItem('ClassName', '');
})

$(document).ready(function() {
  setClassActive();
});

function setClassActive() {
  $('.first-level-item').addClass(localStorage.ClassName);
}
